<ul class="layout-menu">
    <div class="sidebar-top">
        <div class="sidebar-top-inner">
            <img class="sidebar-logo" src="assets/demo/images/champ.png" alt="logo"/>
        </div>
        <div class="logged-in-container" *ngIf="partnerInfo">
            <span class="user-role">{{partnerInfo !==null ? partnerInfo : '--'}}</span>
        </div>
        <hr/>
    </div>
    <ng-container *ngFor="let item of model; let i = index;">
        <li app-menuitem [item]="item" [index]="i" [root]="true"></li>
        <div class="sized-box"></div>
        <li *ngIf="item.separator" class="menu-separator"></li>
    </ng-container>
</ul>
